export default function search() {
    class MainSearch extends HTMLElement {
        constructor() {
            super()

            this.input = this.querySelector('input[type="search"]')
            this.predictiveSearchResults =
                this.querySelector('#predictive-search')
            this.input.addEventListener('focus', this.onFocus.bind(this))
            this.input.form.addEventListener(
                'focusout',
                this.onFocusOut.bind(this)
            )

            this.input.addEventListener(
                'input',
                this.debounce((event) => {
                    this.onChange(event)
                }, 200).bind(this)
            )
        }

        onChange() {
            const searchTerm = this.input.value.trim()

            if (searchTerm.length == 0) {
                this.resetResults()
                return
            }

            if (!searchTerm.length) {
                this.onFocusOut()
                return
            }

            this.getSearchResults(searchTerm)
        }

        getSearchResults(searchTerm) {
            this.loadingState(true)
            //search/suggest?q=bag&resources[type]=product&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title&section_id=predictive-search")
            fetch(
                `/search/suggest?q=${searchTerm}&section_id=predictive-search&resources[type]=product,page,article,collection,query`
            )
                .then((response) => {
                    if (!response.ok) {
                        var error = new Error(response.status)
                        this.onFocusOut()
                        throw error
                    }

                    return response.text()
                })
                .then((text) => {
                    const resultsMarkup = new DOMParser()
                        .parseFromString(text, 'text/html')
                        .querySelector(
                            '#shopify-section-predictive-search'
                        ).innerHTML
                    this.predictiveSearchResults.innerHTML = resultsMarkup
                })
                .catch((error) => {
                    this.onFocusOut()
                    throw error
                })
        }

        onFocus() {
            document.body.classList.add('search-focus')
            // console.log('run on change just in case there is text in there')
            this.onChange()
        }

        onFocusOut(event) {
            if (!event) return
            // if the clicked element is inside of the search form, do nothing
            if (this.input.form.contains(event.relatedTarget)) return
            // otherwise, hide the results and remove focus class
            document.body.classList.remove('search-focus')
            // clear the search input field
            this.input.value = ''
            this.resetResults()
        }

        resetResults() {
            this.predictiveSearchResults.innerHTML = ''
        }

        loadingState(loading = true) {
            if (loading) {
                this.predictiveSearchResults.innerHTML = `
					<div class="loading-ring"><div></div><div></div><div></div><div></div></div>
				`
            } else {
                this.predictiveSearchResults.innerHTML = ''
            }
        }

        debounce(fn, wait) {
            let t
            return (...args) => {
                clearTimeout(t)
                t = setTimeout(() => fn.apply(this, args), wait)
            }
        }
    }
    customElements.define('main-search', MainSearch)
}
